"use strict";

/**
 * Cостояние версии документа.
 *
 * @enum {integer} VERSION_STATE
 * @readonly
 * @since 5.0.0.4218
 * @global
 * @example
 *
 * //Установить для первой версии документа с ИД=123123 состояние «В разработке».
 * WA.SRV.document.version.setState(123123,1,VERSION_STATE.IN_DESING);
 */
var VERSION_STATE = {
  /*Cостояние по умолчанию, указанное в карточке вида документа на закладке «Жизненный цикл».*/
  DEFAULT: 0,
  /** В разработке */
  IN_DESING: 1,
  /** Действующая */
  ACTIVE: 2,
  /** Устаревшая */
  OBSOLETE: 3
};

(function (global) {

  /**
   * Предоставляет инструменты для работы с версиями документа.
   *
   * @namespace WebAccess.services.document.version
   * @since 5.0.0.4218
   */
  global.document.version = {};

  /**
   * Получает имя документа по ИД.
   * @param {number} id ИД документа.
   * @returns {Deferred} Deferred-объект.
   */
  global.document.getNameById = function (ids) {
    var d = $.Deferred();

    WA.SRV.call('/api/LinkQuery.asmx/GetDocumentsById', {
      ids: ids
    }, '', '', true, true).done(function (data) {
      var docs = $.parseJSON(data);
      if (docs && docs.length > 0) {
        d.resolve(docs[0].name);
      } else {
        d.reject(L('ERR_OBJECT_NOT_FOUND'));
      }
    }).fail(function (err) {
      d.reject(err);
    });

    return d.promise();
  }


  /**
   * Изменить примечание версии.
   *
   * @function WebAccess.services.document.version.setNote
   * @param {integer} docId ИД документа
   * @param {integer} verNumber Номер версии документа
   * @param {string} note Текст примечания
   * @return {deferred} Специальный deferred-объект. 
   * @since 5.0.0.4218
   * @example
   *
   * //Установить для первой версии документа с ИД=123123 примечание «Для рассылки».
   * WA.SRV.document.version.setNote(123123,1,"Для рассылки");
   */
  global.document.version.setNote = function (docId, verNumber, note) {
    return global.call("/Document.asmx/ChangeVersionNote", {
      'DocumentID': docId,
      'VersionNumber': verNumber,
      'Note': note
    }, false, false);
  };


  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  /**
   * Изменить состояние версии.
   *
   * @function WebAccess.services.document.version.setState
   * @param {integer} docId ИД документа
   * @param {integer} verNumber Номер версии документа
   * @param {string} state Состояние документа. Глобальная функция VERSION_STATE
   * @return {deferred} Специальный deferred-объект. 
   * @since 5.0.0.4218
   * @example 
   *
   * //Установить для первой версии документа с ИД=123123 состояние «В разработке».
   * WA.SRV.document.version.setState(123123,1,VERSION_STATE.IN_DESING);
   */
  global.document.version.setState = function (docId, verNumber, state) {
    return global.call("/Document.asmx/ChangeVersionState", {
      'DocumentID': docId,
      'VersionNumber': verNumber,
      'State': state
    }, false, false);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.WebAccess.services);